import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowRight, Timer, Lightning } from "@phosphor-icons/react";
import { WALKTHROUGHS, WALKTHROUGH_KEYS } from "../data/walkthroughs";

// /app/walkthrough/:feature — a 1–2 minute, step-by-step tour with "Do it now" deep links.
export default function WalkthroughPage() {
  const { feature } = useParams();
  const w = WALKTHROUGHS[feature];
  if (!w) return <Navigate to="/app/dashboard" replace />;
  return (
    <div className="space-y-8 max-w-3xl" data-testid="walkthrough-page" data-feature={feature}>
      <div>
        <div className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-[#FF9764]"><Timer size={13} /> {w.minutes}-minute walkthrough</div>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold text-white tracking-tight mt-2" data-testid="walkthrough-title">{w.label}</h1>
        <p className="text-neutral-400 mt-2 text-sm sm:text-base">{w.why}</p>
      </div>
      <ol className="space-y-3" data-testid="walkthrough-steps">
        {w.steps.map((s, i) => (
          <li key={s.title} className="card-surface p-5 flex gap-4" data-testid={`walkthrough-step-${i + 1}`}>
            <div className="shrink-0 w-9 h-9 rounded-full bg-[#FF5A1F]/15 text-[#FF5A1F] font-display font-semibold flex items-center justify-center">{i + 1}</div>
            <div className="flex-1">
              <div className="text-white font-semibold">{s.title}</div>
              <p className="text-neutral-400 text-sm mt-1">{s.body}</p>
              {s.to && (
                <Link to={s.to} className="inline-flex items-center gap-1.5 mt-3 text-sm text-[#FF7038] hover:text-[#FF5A1F]" data-testid={`walkthrough-step-${i + 1}-go`}>
                  Do it now <ArrowRight size={13} weight="bold" />
                </Link>
              )}
            </div>
          </li>
        ))}
      </ol>
      <Link to={w.path} className="btn-primary rounded-full px-6 py-3 inline-flex items-center gap-2" data-testid="walkthrough-cta">
        <Lightning size={16} weight="fill" /> Open {w.label} <ArrowRight size={14} weight="bold" />
      </Link>
      <div>
        <div className="text-[10px] uppercase tracking-widest text-neutral-500 mb-2">Other walkthroughs</div>
        <div className="flex flex-wrap gap-2">
          {WALKTHROUGH_KEYS.filter((k) => k !== feature).map((k) => (
            <Link key={k} to={`/app/walkthrough/${k}`} className="rounded-full border border-white/10 px-3 py-1.5 text-xs text-neutral-300 hover:border-white/30 hover:text-white" data-testid={`walkthrough-link-${k}`}>
              {WALKTHROUGHS[k].label} · {WALKTHROUGHS[k].minutes} min
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
